import React ,{useContext}from 'react'
import { Home, Heart, Star } from 'lucide-react'
import { LoadingSpinner } from './UI/LoadingSpinner'
import  BASE_URL  from '../../../services/BaseUrl'
import { Navigate, useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../../GlobalContext' 



export const SavedPropertiesGrid = ({ properties = [], loading = false,savepropertyhandler }) => {
  const navigate = useNavigate();
  const { globalVar } = useContext(GlobalContext);
  const getImageUrl = (path) => `${globalVar}/${path}`;




  if (loading) {
    return <LoadingSpinner text="Loading saved properties..." />
  }
  if (!properties || properties.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-12 text-center">
        <div className="w-24 h-24 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Heart className="w-12 h-12 text-teal-500" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-4">No Saved Properties</h3>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          You haven't saved any properties yet. Start browsing our exclusive collection and save your favorites.
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-8 py-4 bg-teal-500 text-white rounded-xl hover:bg-teal-600 transition-all duration-200 font-medium"
        >
          <Home className="w-5 h-5" />
          Explore Properties
        </a>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {properties.map((item, index) => {
        console.log(item);
        
        const property = item.property_details || item.property || {};
        const primaryImage = property.images && property.images.length > 0
          ? (property.images.find(img => img.is_primary)?.image || property.images[0].image)
          : null;
        const formattedPrice = property.price ? Number(property.price).toLocaleString() : 'N/A';
        return (
          <div key={item.id || index} className="bg-white rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden hover:shadow-xl transition-all duration-300 group">
            <div className="relative">
              {primaryImage ? (
                <img
                  src={getImageUrl(primaryImage)}
                  alt={property.title || 'Property'}
                  className="h-48 w-full object-cover"
                />
              ) : (
                <div className="h-48 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                  <Home className="w-12 h-12 text-gray-400" />
                </div>
              )}
              <button className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-red-500 hover:text-red-600 hover:bg-white transition-all duration-200"
                onClick={() => savepropertyhandler(item.property_details?.id || item.property?.id)}
              >
                <Heart className="w-5 h-5 fill-current" />
              </button>
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1">
                <span className="text-sm font-bold text-gray-900">AED {formattedPrice}</span>
              </div>
            </div>
            <div className="p-6">
              <h3 className="font-bold text-gray-900 mb-2">{property.title || 'Property'}</h3>
              <p className="text-gray-600 text-sm mb-4">
                {property.location?.emirate || 'Location'} • Baths • {property.area || property.area_sqft || 'N/A'} sqft
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" />
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">4.8</span>
                </div>
                <button className="px-4 py-2 text-teal-600 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-all duration-200 text-sm font-medium"
                  onClick={() => property.slug && navigate(`/property-detail/${property.slug}`)}>
                  View Details
                </button>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}